function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.7846 1.55478e-06C17.4194 1.52285e-06 17.0504 0.116771 16.7422 0.350311L0.620082 12.7899C0.22825 13.0928 -1.18449e-06 13.5489 -1.22691e-06 14.0343C-1.26902e-06 14.5159 0.22825 14.9757 0.620082 15.2749L16.6738 27.6489C17.389 28.1999 18.4351 28.0904 19.0095 27.4044C19.584 26.7184 19.4699 25.7149 18.7547 25.1639L4.31395 14.0343L18.8269 2.83532C19.5421 2.28431 19.6563 1.28082 19.0818 0.594798C18.7509 0.204349 18.2715 1.59735e-06 17.7846 1.55478e-06Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.3364 1.55478e-06C29.9712 1.52285e-06 29.6021 0.116771 29.294 0.350311L13.1718 12.7899C12.78 13.0928 12.5518 13.5489 12.5518 14.0343C12.5518 14.5159 12.78 14.9757 13.1718 15.2749L29.2255 27.6489C29.9407 28.1999 30.9869 28.0904 31.5613 27.4044C32.1357 26.7184 32.0216 25.7149 31.3064 25.1639L16.8657 14.0343L31.3787 2.83532C32.0939 2.28431 32.208 1.28082 31.6336 0.594798C31.3026 0.204349 30.8233 1.59735e-06 30.3364 1.55478e-06Z",
  fill: "currentColor"
});

var SvgIcDoubleLeftArrow = function SvgIcDoubleLeftArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcDoubleLeftArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_double_left_arrow.95ac41b2.svg";
export { ForwardRef as ReactComponent };